import { RouteConfig } from "vue-router";
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

function isMobile() {
  let check = false;

  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);
  return check;
}

const SelfcareRoutes: Array<RouteConfig> = [
  {
    path: "/admin/dashboard",
    alias: ["/admin", "/admin/", "/", "/blank"],
    name: "dashboard",
    meta: { requireAuth: true, layout: MasterLayout },
    component: () =>
      isMobile()
        ? import("../views/SelfCare/DashBoard.vue")
        : import("../views/SelfCare/DashBoard.vue"),
  },

  {
    path: "/admin/my-account",
    name: "my-account",
    component: () => import("../views/SelfCare/MyAccountShow.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/info-update",
    name: "info-update",
    component: () => import("../views/SelfCare/MyAccountUpdate.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/usage",
    name: "usage",
    component: () =>
      isMobile()
        ? import("../views/SelfCare/UsageCardView.vue")
        : import("../views/SelfCare/Usage.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/support-ticket",
    name: "support-ticket",
    component: () =>
      isMobile()
        ? import("../views/SelfCare/SupportTicketCardList.vue")
        : import("../views/SelfCare/SupportTicket.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/open-ticket",
    name: "open-ticket",
    component: () => import("../views/SelfCare/OpenTicket.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/paybill",
    name: "paybill",
    component: () =>
      isMobile()
        ? import("../views/SelfCare/PaybillCardView.vue")
        : import("../views/SelfCare/Paybill.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/paynow",
    name: "paynow",
    component: () => import("../views/SelfCare/Paynow.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/bkash-gw",
    name: "bkash-gw",
    component: () => import("../views/SelfCare/bKashGateway.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/bkash",
    name: "bkash",
    component: () => import("../views/SelfCare/BKashPayment.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/terms-conditions",
    name: "terms-conditions",
    component: () => import("../views/SelfCare/TermAndCondition.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/SelfCare/PrivacyPolicy.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/refund-policy",
    name: "refund-policy",
    component: () => import("../views/SelfCare/RefundPolicy.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/change-password",
    name: "change-password",
    component: () => import("../views/SelfCare/ChangePassword.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/paymentResult",
    name: "payment-result",
    component: () => import("../views/SelfCare/PaymentSuccess.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/topup_status",
    name: "topup_payment_status",
    component: () => import("../views/SelfCare/PaymentSuccess.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/recharge-history",
    name: "recharge-history",
    component: () =>
      isMobile()
        ? import("../views/SelfCare/RechargeHistoryCardView.vue")
        : import("../views/SelfCare/RechargeHistory.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/topup",
    name: "topup",
    component: () => import("../views/SelfCare/Topup.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  // {
  //   path: '/admin/topup/payment',
  //   name: 'topup_payment',
  //   component: () => import('../views/SelfCare/TopupEntry.vue'),
  //   meta: { requireAuth: true, layout: MasterLayout },
  //   props: true
  // },

  {
    path: "/admin/topup/payment",
    name: "topup_payment",
    component: () => import("../views/SelfCare/TopupEntrySec.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
    props: true,
  },

  {
    path: "/admin/topup/payment_confirm",
    name: "topup_payment_confirm",
    component: () => import("../views/SelfCare/TopupConfirm.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
    props: true,
  },

  // {
  //   path: "/admin/my_page",
  //   name: "topup_payment_confirm",
  //   component: () => import("../views/SelfCare/MyPage.vue"),
  //   meta: { requireAuth: true, layout: MasterLayout },
  //   props: true,
  // },

  {
    path: "/admin/topup/payment",
    name: "topup_payment",
    component: () => import("../views/SelfCare/TopupEntry.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
    props: true,
  },
  {
    path: "/admin/topup/payment_confirm",
    name: "topup_payment_confirm",
    component: () => import("../views/SelfCare/TopupConfirm.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
    props: true,
  },
  {
    path: "/admin/support",
    name: "support",
    component: () => import("../views/SelfCare/Support.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/ticket-details/:id",
    name: "ticket-details",
    component: () => import("../views/SelfCare/TicketDetails.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/notifications",
    name: "notifications",
    component: () => import("../views/SelfCare/Notifications.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/package",
    name: "my_package",
    component: () => import("../views/SelfCare/MyPackage.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/service_status",
    name: "service_status",
    component: () => import("../views/SelfCare/ServiceStatus.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/offers",
    name: "offers",
    component: () => import("../views/SelfCare/offers.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  // {
  //   path: "/admin/devices",
  //   name: "devices",
  //   component: () => import("../views/SelfCare/Devices.vue"),
  //   meta: { requireAuth: true, layout: MasterLayout },
  // },
  {
    path: "/admin/devices",
    name: "devices",
    component: () => import("../views/SelfCare/DevicesNew.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/orders",
    name: "orders",
    component: () => import("../views/SelfCare/OrderTracking.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/address-change-request",
    name: "address-change-request",
    component: () => import("../views/SelfCare/AddressChangeRequest.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/my-chat",
    name: "mychat",
    component: () => import("../views/SelfCare/MyChat.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },

  {
    path: "/admin/billing_histories",
    name: "billing_histories",
    component: () => import("../views/SelfCare/BillingHistory.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  },
  {
    path: "/admin/show-card-info",
    name: "show-card-info",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: { requireAuth: true, layout: MasterLayout },
  }
];

export default SelfcareRoutes;
